/**
 * Created by laugh on 10/17/2017.
 */
export default function (state = "", action) {

    switch (action.type) {
        case 'ORDER_CONFIRMATION':
            return action.setOrderConfirmation;
        case 'CLEAR_CONFIRMATION':
            return undefined;
        default:
            return state
    }

}


// WEBPACK FOOTER //
// ./src/reducers/order-confirmation.js